import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Box } from '@mui/material';
import { CorrelationIdLink } from './SnackbarStyles';

const WarningToast = ({ message, correlationId, viewLogs }) => {
  const history = useHistory();

  const redirectToLog = useCallback(
    correlationId => {
      history.push(`/logs/systemLogs?correlationId=${correlationId}`, { reload: true });
    },
    [history]
  );

  return (
    <Box display='flex' flexDirection='column'>
      {message}
      <CorrelationIdLink onClick={viewLogs && (() => redirectToLog(correlationId))} active={viewLogs}>
        {correlationId}
      </CorrelationIdLink>
    </Box>
  );
};

WarningToast.propTypes = {
  message: PropTypes.string,
  correlationId: PropTypes.string,
  viewLogs: PropTypes.bool.isRequired
};

export default WarningToast;
